<ion-content class="ion-padding">
    <app-ai-summary-content
            [participant]="participant"
            [cycleParticipantId]="cycleParticipantId"
            [isExportMode]="false"
    >

        </app-ai-summary-content>
    <div style="width: 100%;height: 69px;"></div>

</ion-content>

<ion-footer mode="ios" *ngIf="!isExportMode">
    <ion-toolbar mode="ios">
        <ion-row>
            <ion-col size="12">
                <div style="display: flex;justify-content: space-between;">
                    <div class="button-wrapper">
                        <ion-button mode="ios" color="secondary" (click)="dismiss(false)">
                            {{ 'generic.close' | translate }}
                        </ion-button>
                        <ion-button fill="clear" color="secondary" mode="ios" (click)="export()">
                            <img src="./assets/imgs/exportar_resumo_icon.svg"
                                 alt=""/>&nbsp; {{
                                'generic.export' | translate
                            }}
                        </ion-button>
                    </div>

                    <div class="button-wrapper">
                        <ion-button fill="clear" color="secondary" mode="ios" (click)="viewFullReport()">
                            <img src="./assets/imgs/Relatorio_Completo_icon.svg" />&nbsp; {{
                                'calibration.fullReport' | translate
                            }}
                        </ion-button>
                    </div>
                </div>
            </ion-col>
        </ion-row>
    </ion-toolbar>
</ion-footer>